import { createAsyncThunk } from "@reduxjs/toolkit";
import type { RootState, AppDispatch } from "./main";
import { WndError } from 'wnd-react-utils/lib/errors';

// This has to be in a separate file than main because without the
// `import type` import at the top, we have a circular dependency
export const createAppAsyncThunk = createAsyncThunk.withTypes<{
  state: RootState;
  dispatch: AppDispatch;
  serializedErrorType: WndError;
}>();

